import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import CopyAPIKeyModal from './CopyAPIKeyModal';
import styles from './RegenerateAPIKeyModal.module.scss';
export const RegenerateAPIKeyModal = (param)=>{
    let { apiKey, dismissModal, refresh } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('pages.apiKeysPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'regenerate_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'regenerate_a_p_i_key_cancel'
            }
        },
        title: apiKeysPageTexts.regenerateTitle(),
        content: /*#__PURE__*/ _jsxs(Typography, {
            className: styles.regenerateApiKeyModalContent,
            testId: "regenerate-api-key-modal-content",
            children: [
                apiKeysPageTexts.regenerateContent(),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                apiKeysPageTexts.regenerateConfirm()
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.regenerateApiKey(),
        onPrimaryButtonClick: async ()=>{
            try {
                const { apiKey: apiKeyValue } = await api.business.regenerateAPIKey(apiKey.id);
                await refresh();
                overlayContext.showModal({
                    biName: 'copy_api_key_modal',
                    content: (param)=>{
                        let { dismissModal } = param;
                        return /*#__PURE__*/ _jsx(CopyAPIKeyModal, {
                            apiKeyName: apiKey.name,
                            apiKeyValue: apiKeyValue,
                            dismissModal: dismissModal
                        });
                    }
                });
            } catch (error) {
                overlayContext.showErrorToast(commonTexts.toasts.failedToRegenerateApiKey(), 'regenerate-api-key-error');
            } finally{
                dismissModal();
            }
        },
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: dismissModal,
        testId: "regenerate-api-key-modal"
    });
};
